<template>
  <ul class="lang-switch p-0 m-0">
    <li v-if="languages" v-for="lang in languages" v-bind:key="lang.code">
      <a :href="lang.href" :class="{'current-language': locale === lang.code }">{{lang.title}}</a>
    </li>
  </ul>
</template>

<script>

import {HTTP} from '../http-common';

export default {
  name: 'LangSwithcer',

  data() {
    return {
      locale: 'en',
      languages: null,
      errors: []
    }
  },

  created() {
    this.fetchData()
  },

  watch:{
    $route (to, from) {
      this.languages = null
      this.fetchData()
    }
  },

  mounted() {
    function appendLang(){
      if ($(window).width() < 769){
        $('.lang-switch').appendTo('.contacts-header-wrapper .social-bar-footer')
      } else if($(window).width() > 769){
        $('.lang-switch').appendTo('.side-fixed-block')
      }
    }

    appendLang()

    $(window).resize(function(){
      appendLang();
    })

    $('.lang-switch li').on('click', function(){
      $('#menu-close').trigger('click');
    })
  },

  methods: {
    fetchData() {
      this.locale = this.$root.locale
      this.languages = this.$root.languages

      document.getElementsByTagName('html')[0].lang = this.locale

      let path = this.$route.fullPath

      console.log(this.$route.params.locale)

      //if (!this.$route.params.locale)
        //path = '/en' + path

      for(let code in this.languages) {
      	 this.languages[code].href = `https://${code}.gtagency.de${path.replace('/' + this.locale, '')}`
	 // this.languages[code].href = path.replace('/' + this.locale, '/' + code)
      }
    }
  }
}


</script>
